import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';

import { getInfoWatcher } from './sagas';
import appReducer from './reducers/appReducer';

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();

// dev tools middleware
// const reduxDevTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();

// create a redux store with our reducer above and middleware
export const appStore = createStore(
  appReducer,
  compose(
    applyMiddleware(sagaMiddleware),
    // reduxDevTools,
  ),
);

// run the saga
sagaMiddleware.run(getInfoWatcher);
